import React from 'react';
import {ThemeProvider as MuiThemeProvider} from '@material-ui/core/styles';
import styled, {ThemeProvider as StyledThemeProvider} from 'styled-components';
import {ueDarkTheme} from './ueDarkTheme';

const ChildrenWithStyle = styled.div`
    background: ${(p) => p.theme.palette.background.default};
    color: ${(p) => p.theme.palette.text.primary};
`;

interface Properties {
    children: React.ReactNode;
    theme?: {[key: string]: any};
}

export const UeThemeProvider = ({children, theme}: Properties): JSX.Element => {
    const merged = {
        ...ueDarkTheme,
        ...theme
    };

    const ueFonts = merged.ue.fonts;
    merged.fonts = ueFonts;

    return (
        <MuiThemeProvider theme={merged}>
            <StyledThemeProvider theme={merged}>
                <ChildrenWithStyle>{children}</ChildrenWithStyle>
            </StyledThemeProvider>
        </MuiThemeProvider>
    );
};

export default UeThemeProvider;
